import Project from "./Project";
import Title from "./Title";

export default function ProjectSection({ projects }) {

    return (<section className="py-10 sm:py-16" >
    <Title
      title={"Tussenconcepten"}
      subtitle={'Onze drie tussenconcepten voor het thema "Nieuw publiek (be)trekken en vasthouden"'}
    />
    <div className="flex flex-col gap-16 sm:gap-32">
    {projects.map((project) => (
      <Project key={project.title} {...project} />
    ))}
    </div>
    </section>)

}

